module.exports = __webpack_public_path__ + "Alex-5824b560.png";